/* eslint-disabled */

export default class EnginePlaceExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
